import { QUANT_TRACKS } from './quantProfileUtils';

export const QUANT_WEEKEND_MODULES = [
  {
    week: 1,
    label: 'Arithmetic Foundations',
    lessonId: 'arithmetic-foundations',
    topicIds: ['number_properties', 'ratios_percents', 'unit_conversions'],
  },
  {
    week: 2,
    label: 'Math Translation',
    lessonId: 'math-translation',
    topicIds: ['general_word_problems', 'algebra', 'rates'],
  },
  {
    week: 3,
    label: 'Math Shortcuts',
    lessonId: 'math-shortcuts',
    topicIds: ['number_properties', 'ratios_percents', 'general_word_problems'],
  },
  {
    week: 4,
    label: 'Percentages and Ratios',
    lessonId: 'percentage-ratio',
    topicIds: ['ratios_percents', 'general_word_problems'],
  },
  {
    week: 5,
    label: 'Graphs and Data Reading',
    lessonId: 'graphs',
    topicIds: ['data_interpretation_questions', 'statistics'],
  },
  {
    week: 6,
    label: 'Statistics Basics',
    lessonId: 'statistics',
    topicIds: ['statistics', 'data_analysis_problems'],
  },
  {
    week: 7,
    label: 'Integers and Number Properties',
    lessonId: 'integers',
    topicIds: ['number_properties'],
  },
  {
    week: 8,
    label: 'Exponents and Roots',
    lessonId: 'exponents',
    topicIds: ['exponents', 'roots'],
  },
  {
    week: 9,
    label: 'Algebra and Quadratics',
    lessonId: 'algebra',
    topicIds: ['algebra', 'linear_quadratic', 'inequalities'],
  },
  {
    week: 10,
    label: 'Absolute Value and Inequalities',
    lessonId: 'absolute-value',
    topicIds: ['absolute_value', 'inequalities'],
  },
  {
    week: 11,
    label: 'Sequences',
    lessonId: 'sequences',
    topicIds: ['sequences'],
  },
  {
    week: 12,
    label: 'Rates and Unit Conversions',
    lessonId: 'distance-rate',
    topicIds: ['rates', 'unit_conversions'],
  },
  {
    week: 13,
    label: 'Work Problems',
    lessonId: 'work-rate',
    topicIds: ['work_problems', 'rates'],
  },
  {
    week: 14,
    label: 'Sets and Venn Diagrams',
    lessonId: 'sets',
    topicIds: ['overlapping_sets'],
  },
  {
    week: 15,
    label: 'Probability Basics',
    lessonId: 'probabilities',
    topicIds: ['probability'],
  },
  {
    week: 16,
    label: 'Counting and Restricted Arrangements',
    lessonId: 'probabilities',
    topicIds: ['combinations_permutations', 'probability'],
  },
  {
    week: 17,
    label: 'Geometry Toolkit',
    lessonId: 'coordinate-geometry',
    topicIds: ['coordinate_geometry', 'geometry'],
  },
  { week: 18, label: 'Triangles', lessonId: 'triangles', topicIds: ['geometry'] },
  {
    week: 19,
    label: 'Circles and Polygons',
    lessonId: 'circles',
    topicIds: ['geometry'],
  },
  {
    week: 20,
    label: '3D Geometry and Volume',
    lessonId: 'volumes',
    topicIds: ['geometry'],
  },
  {
    week: 21,
    label: 'Data Interpretation',
    lessonId: 'graphs',
    topicIds: ['data_interpretation_questions', 'statistics'],
  },
  {
    week: 22,
    label: 'Mixed Algebra Review',
    lessonId: 'algebra',
    topicIds: ['algebra', 'linear_quadratic', 'inequalities', 'functions'],
  },
  {
    week: 23,
    label: 'Mixed Arithmetic Review',
    lessonId: 'integers',
    topicIds: ['number_properties', 'ratios_percents', 'exponents', 'roots'],
  },
  {
    week: 24,
    label: 'Mixed Geometry Review',
    lessonId: 'triangles',
    topicIds: ['geometry', 'coordinate_geometry'],
  },
  {
    week: 25,
    label: 'Hard/Very Hard Review',
    lessonId: 'math-shortcuts',
    topicIds: [
      'number_properties',
      'algebra',
      'linear_quadratic',
      'geometry',
      'statistics',
    ],
  },
  {
    week: 26,
    label: 'Final Quant Readiness',
    lessonId: 'graphs',
    topicIds: [
      'number_properties',
      'algebra',
      'geometry',
      'statistics',
      'data_interpretation_questions',
    ],
  },
];

export const getSundayDifficultyMix = (weekNumber) => {
  if (weekNumber <= 4) return { medium: 0.7, hard: 0.3, very_hard: 0 };
  if (weekNumber <= 12) return { medium: 0.5, hard: 0.5, very_hard: 0 };
  if (weekNumber <= 20) return { medium: 0.3, hard: 0.6, very_hard: 0.1 };
  return { medium: 0.2, hard: 0.5, very_hard: 0.3 };
};

export const getSundayPracticeStageLabel = (weekNumber) => {
  const mix = getSundayDifficultyMix(weekNumber);
  return Object.entries(mix)
    .filter(([, value]) => value > 0)
    .map(([difficulty, value]) => {
      const label = difficulty === 'very_hard' ? 'very hard' : difficulty;
      return `${Math.round(value * 100)}% ${label}`;
    })
    .join(' · ');
};

export const getEffectiveQuantWeekNumber = (rawWeekNumber, quantTrack) => {
  const safeWeek = Math.max(1, Number(rawWeekNumber) || 1);
  const adjustedWeek =
    quantTrack === QUANT_TRACKS.ACCELERATION ? safeWeek + 3 : safeWeek;
  return Math.min(QUANT_WEEKEND_MODULES.length, adjustedWeek);
};

export const getQuantWeekendModule = (weekNumber) =>
  QUANT_WEEKEND_MODULES[
    Math.min(QUANT_WEEKEND_MODULES.length, Math.max(1, weekNumber)) - 1
  ] || QUANT_WEEKEND_MODULES[0];
